const mockRepos = [
  {
  id: 324060761,
  node_id: "MDEwOlJlcG9zaXRvcnkzMjQwNjA3NjE=",
  name: "color-generator",
  full_name: "thilak009/color-generator",
  private: false,
  owner: {
  login: "thilak009",
  id: 56732160,
  node_id: "MDQ6VXNlcjU2NzMyMTYw",
  avatar_url: "https://avatars3.githubusercontent.com/u/56732160?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/thilak009",
  html_url: "https://github.com/thilak009",
  followers_url: "https://api.github.com/users/thilak009/followers",
  following_url: "https://api.github.com/users/thilak009/following{/other_user}",
  gists_url: "https://api.github.com/users/thilak009/gists{/gist_id}",
  starred_url: "https://api.github.com/users/thilak009/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/thilak009/subscriptions",
  organizations_url: "https://api.github.com/users/thilak009/orgs",
  repos_url: "https://api.github.com/users/thilak009/repos",
  events_url: "https://api.github.com/users/thilak009/events{/privacy}",
  received_events_url: "https://api.github.com/users/thilak009/received_events",
  type: "User",
  site_admin: false
  },
  html_url: "https://github.com/thilak009/color-generator",
  description: null,
  fork: false,
  url: "https://api.github.com/repos/thilak009/color-generator",
  forks_url: "https://api.github.com/repos/thilak009/color-generator/forks",
  keys_url: "https://api.github.com/repos/thilak009/color-generator/keys{/key_id}",
  collaborators_url: "https://api.github.com/repos/thilak009/color-generator/collaborators{/collaborator}",
  teams_url: "https://api.github.com/repos/thilak009/color-generator/teams",
  hooks_url: "https://api.github.com/repos/thilak009/color-generator/hooks",
  issue_events_url: "https://api.github.com/repos/thilak009/color-generator/issues/events{/number}",
  events_url: "https://api.github.com/repos/thilak009/color-generator/events",
  assignees_url: "https://api.github.com/repos/thilak009/color-generator/assignees{/user}",
  branches_url: "https://api.github.com/repos/thilak009/color-generator/branches{/branch}",
  tags_url: "https://api.github.com/repos/thilak009/color-generator/tags",
  blobs_url: "https://api.github.com/repos/thilak009/color-generator/git/blobs{/sha}",
  git_tags_url: "https://api.github.com/repos/thilak009/color-generator/git/tags{/sha}",
  git_refs_url: "https://api.github.com/repos/thilak009/color-generator/git/refs{/sha}",
  trees_url: "https://api.github.com/repos/thilak009/color-generator/git/trees{/sha}",
  statuses_url: "https://api.github.com/repos/thilak009/color-generator/statuses/{sha}",
  languages_url: "https://api.github.com/repos/thilak009/color-generator/languages",
  stargazers_url: "https://api.github.com/repos/thilak009/color-generator/stargazers",
  contributors_url: "https://api.github.com/repos/thilak009/color-generator/contributors",
  subscribers_url: "https://api.github.com/repos/thilak009/color-generator/subscribers",
  subscription_url: "https://api.github.com/repos/thilak009/color-generator/subscription",
  commits_url: "https://api.github.com/repos/thilak009/color-generator/commits{/sha}",
  git_commits_url: "https://api.github.com/repos/thilak009/color-generator/git/commits{/sha}",
  comments_url: "https://api.github.com/repos/thilak009/color-generator/comments{/number}",
  issue_comment_url: "https://api.github.com/repos/thilak009/color-generator/issues/comments{/number}",
  contents_url: "https://api.github.com/repos/thilak009/color-generator/contents/{+path}",
  compare_url: "https://api.github.com/repos/thilak009/color-generator/compare/{base}...{head}",
  merges_url: "https://api.github.com/repos/thilak009/color-generator/merges",
  archive_url: "https://api.github.com/repos/thilak009/color-generator/{archive_format}{/ref}",
  downloads_url: "https://api.github.com/repos/thilak009/color-generator/downloads",
  issues_url: "https://api.github.com/repos/thilak009/color-generator/issues{/number}",
  pulls_url: "https://api.github.com/repos/thilak009/color-generator/pulls{/number}",
  milestones_url: "https://api.github.com/repos/thilak009/color-generator/milestones{/number}",
  notifications_url: "https://api.github.com/repos/thilak009/color-generator/notifications{?since,all,participating}",
  labels_url: "https://api.github.com/repos/thilak009/color-generator/labels{/name}",
  releases_url: "https://api.github.com/repos/thilak009/color-generator/releases{/id}",
  deployments_url: "https://api.github.com/repos/thilak009/color-generator/deployments",
  created_at: "2020-12-24T03:58:35Z",
  updated_at: "2020-12-26T06:48:08Z",
  pushed_at: "2020-12-24T04:26:09Z",
  git_url: "git://github.com/thilak009/color-generator.git",
  ssh_url: "git@github.com:thilak009/color-generator.git",
  clone_url: "https://github.com/thilak009/color-generator.git",
  svn_url: "https://github.com/thilak009/color-generator",
  homepage: null,
  size: 169,
  stargazers_count: 0,
  watchers_count: 0,
  language: "CSS",
  has_issues: true,
  has_projects: true,
  has_downloads: true,
  has_wiki: true,
  has_pages: false,
  forks_count: 0,
  mirror_url: null,
  archived: false,
  disabled: false,
  open_issues_count: 0,
  license: null,
  forks: 0,
  open_issues: 0,
  watchers: 0,
  default_branch: "main"
  },
  {
  id: 323541738,
  node_id: "MDEwOlJlcG9zaXRvcnkzMjM1NDE3Mzg=",
  name: "git-task",
  full_name: "thilak009/git-task",
  private: false,
  owner: {
  login: "thilak009",
  id: 56732160,
  node_id: "MDQ6VXNlcjU2NzMyMTYw",
  avatar_url: "https://avatars3.githubusercontent.com/u/56732160?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/thilak009",
  html_url: "https://github.com/thilak009",
  followers_url: "https://api.github.com/users/thilak009/followers",
  following_url: "https://api.github.com/users/thilak009/following{/other_user}",
  gists_url: "https://api.github.com/users/thilak009/gists{/gist_id}",
  starred_url: "https://api.github.com/users/thilak009/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/thilak009/subscriptions",
  organizations_url: "https://api.github.com/users/thilak009/orgs",
  repos_url: "https://api.github.com/users/thilak009/repos",
  events_url: "https://api.github.com/users/thilak009/events{/privacy}",
  received_events_url: "https://api.github.com/users/thilak009/received_events",
  type: "User",
  site_admin: false
  },
  html_url: "https://github.com/thilak009/git-task",
  description: null,
  fork: true,
  url: "https://api.github.com/repos/thilak009/git-task",
  forks_url: "https://api.github.com/repos/thilak009/git-task/forks",
  keys_url: "https://api.github.com/repos/thilak009/git-task/keys{/key_id}",
  collaborators_url: "https://api.github.com/repos/thilak009/git-task/collaborators{/collaborator}",
  teams_url: "https://api.github.com/repos/thilak009/git-task/teams",
  hooks_url: "https://api.github.com/repos/thilak009/git-task/hooks",
  issue_events_url: "https://api.github.com/repos/thilak009/git-task/issues/events{/number}",
  events_url: "https://api.github.com/repos/thilak009/git-task/events",
  assignees_url: "https://api.github.com/repos/thilak009/git-task/assignees{/user}",
  branches_url: "https://api.github.com/repos/thilak009/git-task/branches{/branch}",
  tags_url: "https://api.github.com/repos/thilak009/git-task/tags",
  blobs_url: "https://api.github.com/repos/thilak009/git-task/git/blobs{/sha}",
  git_tags_url: "https://api.github.com/repos/thilak009/git-task/git/tags{/sha}",
  git_refs_url: "https://api.github.com/repos/thilak009/git-task/git/refs{/sha}",
  trees_url: "https://api.github.com/repos/thilak009/git-task/git/trees{/sha}",
  statuses_url: "https://api.github.com/repos/thilak009/git-task/statuses/{sha}",
  languages_url: "https://api.github.com/repos/thilak009/git-task/languages",
  stargazers_url: "https://api.github.com/repos/thilak009/git-task/stargazers",
  contributors_url: "https://api.github.com/repos/thilak009/git-task/contributors",
  subscribers_url: "https://api.github.com/repos/thilak009/git-task/subscribers",
  subscription_url: "https://api.github.com/repos/thilak009/git-task/subscription",
  commits_url: "https://api.github.com/repos/thilak009/git-task/commits{/sha}",
  git_commits_url: "https://api.github.com/repos/thilak009/git-task/git/commits{/sha}",
  comments_url: "https://api.github.com/repos/thilak009/git-task/comments{/number}",
  issue_comment_url: "https://api.github.com/repos/thilak009/git-task/issues/comments{/number}",
  contents_url: "https://api.github.com/repos/thilak009/git-task/contents/{+path}",
  compare_url: "https://api.github.com/repos/thilak009/git-task/compare/{base}...{head}",
  merges_url: "https://api.github.com/repos/thilak009/git-task/merges",
  archive_url: "https://api.github.com/repos/thilak009/git-task/{archive_format}{/ref}",
  downloads_url: "https://api.github.com/repos/thilak009/git-task/downloads",
  issues_url: "https://api.github.com/repos/thilak009/git-task/issues{/number}",
  pulls_url: "https://api.github.com/repos/thilak009/git-task/pulls{/number}",
  milestones_url: "https://api.github.com/repos/thilak009/git-task/milestones{/number}",
  notifications_url: "https://api.github.com/repos/thilak009/git-task/notifications{?since,all,participating}",
  labels_url: "https://api.github.com/repos/thilak009/git-task/labels{/name}",
  releases_url: "https://api.github.com/repos/thilak009/git-task/releases{/id}",
  deployments_url: "https://api.github.com/repos/thilak009/git-task/deployments",
  created_at: "2020-12-22T06:29:21Z",
  updated_at: "2020-12-25T06:38:53Z",
  pushed_at: "2020-12-25T06:38:50Z",
  git_url: "git://github.com/thilak009/git-task.git",
  ssh_url: "git@github.com:thilak009/git-task.git",
  clone_url: "https://github.com/thilak009/git-task.git",
  svn_url: "https://github.com/thilak009/git-task",
  homepage: null,
  size: 0,
  stargazers_count: 0,
  watchers_count: 0,
  language: null,
  has_issues: false,
  has_projects: true,
  has_downloads: true,
  has_wiki: true,
  has_pages: false,
  forks_count: 0,
  mirror_url: null,
  archived: false,
  disabled: false,
  open_issues_count: 0,
  license: null,
  forks: 0,
  open_issues: 0,
  watchers: 0,
  default_branch: "main"
  },
  {
  id: 324488983,
  node_id: "MDEwOlJlcG9zaXRvcnkzMjQ0ODg5ODM=",
  name: "stripe-menu",
  full_name: "thilak009/stripe-menu",
  private: false,
  owner: {
  login: "thilak009",
  id: 56732160,
  node_id: "MDQ6VXNlcjU2NzMyMTYw",
  avatar_url: "https://avatars3.githubusercontent.com/u/56732160?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/thilak009",
  html_url: "https://github.com/thilak009",
  followers_url: "https://api.github.com/users/thilak009/followers",
  following_url: "https://api.github.com/users/thilak009/following{/other_user}",
  gists_url: "https://api.github.com/users/thilak009/gists{/gist_id}",
  starred_url: "https://api.github.com/users/thilak009/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/thilak009/subscriptions",
  organizations_url: "https://api.github.com/users/thilak009/orgs",
  repos_url: "https://api.github.com/users/thilak009/repos",
  events_url: "https://api.github.com/users/thilak009/events{/privacy}",
  received_events_url: "https://api.github.com/users/thilak009/received_events",
  type: "User",
  site_admin: false
  },
  html_url: "https://github.com/thilak009/stripe-menu",
  description: null,
  fork: false,
  url: "https://api.github.com/repos/thilak009/stripe-menu",
  forks_url: "https://api.github.com/repos/thilak009/stripe-menu/forks",
  keys_url: "https://api.github.com/repos/thilak009/stripe-menu/keys{/key_id}",
  collaborators_url: "https://api.github.com/repos/thilak009/stripe-menu/collaborators{/collaborator}",
  teams_url: "https://api.github.com/repos/thilak009/stripe-menu/teams",
  hooks_url: "https://api.github.com/repos/thilak009/stripe-menu/hooks",
  issue_events_url: "https://api.github.com/repos/thilak009/stripe-menu/issues/events{/number}",
  events_url: "https://api.github.com/repos/thilak009/stripe-menu/events",
  assignees_url: "https://api.github.com/repos/thilak009/stripe-menu/assignees{/user}",
  branches_url: "https://api.github.com/repos/thilak009/stripe-menu/branches{/branch}",
  tags_url: "https://api.github.com/repos/thilak009/stripe-menu/tags",
  blobs_url: "https://api.github.com/repos/thilak009/stripe-menu/git/blobs{/sha}",
  git_tags_url: "https://api.github.com/repos/thilak009/stripe-menu/git/tags{/sha}",
  git_refs_url: "https://api.github.com/repos/thilak009/stripe-menu/git/refs{/sha}",
  trees_url: "https://api.github.com/repos/thilak009/stripe-menu/git/trees{/sha}",
  statuses_url: "https://api.github.com/repos/thilak009/stripe-menu/statuses/{sha}",
  languages_url: "https://api.github.com/repos/thilak009/stripe-menu/languages",
  stargazers_url: "https://api.github.com/repos/thilak009/stripe-menu/stargazers",
  contributors_url: "https://api.github.com/repos/thilak009/stripe-menu/contributors",
  subscribers_url: "https://api.github.com/repos/thilak009/stripe-menu/subscribers",
  subscription_url: "https://api.github.com/repos/thilak009/stripe-menu/subscription",
  commits_url: "https://api.github.com/repos/thilak009/stripe-menu/commits{/sha}",
  git_commits_url: "https://api.github.com/repos/thilak009/stripe-menu/git/commits{/sha}",
  comments_url: "https://api.github.com/repos/thilak009/stripe-menu/comments{/number}",
  issue_comment_url: "https://api.github.com/repos/thilak009/stripe-menu/issues/comments{/number}",
  contents_url: "https://api.github.com/repos/thilak009/stripe-menu/contents/{+path}",
  compare_url: "https://api.github.com/repos/thilak009/stripe-menu/compare/{base}...{head}",
  merges_url: "https://api.github.com/repos/thilak009/stripe-menu/merges",
  archive_url: "https://api.github.com/repos/thilak009/stripe-menu/{archive_format}{/ref}",
  downloads_url: "https://api.github.com/repos/thilak009/stripe-menu/downloads",
  issues_url: "https://api.github.com/repos/thilak009/stripe-menu/issues{/number}",
  pulls_url: "https://api.github.com/repos/thilak009/stripe-menu/pulls{/number}",
  milestones_url: "https://api.github.com/repos/thilak009/stripe-menu/milestones{/number}",
  notifications_url: "https://api.github.com/repos/thilak009/stripe-menu/notifications{?since,all,participating}",
  labels_url: "https://api.github.com/repos/thilak009/stripe-menu/labels{/name}",
  releases_url: "https://api.github.com/repos/thilak009/stripe-menu/releases{/id}",
  deployments_url: "https://api.github.com/repos/thilak009/stripe-menu/deployments",
  created_at: "2020-12-26T05:34:28Z",
  updated_at: "2020-12-26T05:47:22Z",
  pushed_at: "2020-12-26T05:47:19Z",
  git_url: "git://github.com/thilak009/stripe-menu.git",
  ssh_url: "git@github.com:thilak009/stripe-menu.git",
  clone_url: "https://github.com/thilak009/stripe-menu.git",
  svn_url: "https://github.com/thilak009/stripe-menu",
  homepage: null,
  size: 243,
  stargazers_count: 0,
  watchers_count: 0,
  language: "CSS",
  has_issues: true,
  has_projects: true,
  has_downloads: true,
  has_wiki: true,
  has_pages: false,
  forks_count: 0,
  mirror_url: null,
  archived: false,
  disabled: false,
  open_issues_count: 0,
  license: null,
  forks: 0,
  open_issues: 0,
  watchers: 0,
  default_branch: "main"
  }
  ]

  export default mockRepos;